import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapNoteFromServer = getDataMapper({
    id: mapField("id", Number),
    text: mapField("text"),
    channel: mapField("channel"),
    createdAt: mapField("created_at"),
    createdUserId: mapField("created_user_id"),
    createdUserName: mapField("created_user_name"),
});

export const mapNotesFromServer = mapArray(mapNoteFromServer);
